import React from 'react';
import { SectionHeader } from './SectionHeader';
const painPoints = [{
  icon: '😰',
  title: 'No sabés por dónde empezar',
  desc: 'Sin un plan claro, abrís el apunte y cerrás el apunte sin haber hecho nada.'
}, {
  icon: '😶',
  title: 'Te quedás en blanco en el examen',
  desc: 'Estudiaste, sabías el tema, pero en la mesa todo se borró.'
}, {
  icon: '😴',
  title: 'No podés dormir la noche anterior',
  desc: 'La cabeza no para y llegás al examen agotado.'
}, {
  icon: '📱',
  title: 'Te distraés apenas arrancás',
  desc: 'El celular, las notificaciones, el ruido. Concentrarte se vuelve imposible.'
}, {
  icon: '📚',
  title: 'Dejás todo para último momento',
  desc: 'Y cuando querés arrancar, ya no queda tiempo.'
}, {
  icon: '😔',
  title: 'Reprobaste y no sabés qué hacer',
  desc: 'La frustración te paraliza y no encontrás cómo volver a arrancar.'
}, {
  icon: '⏰',
  title: 'Estudiás mucho pero rendís poco',
  desc: 'Pasás horas con los apuntes y la nota no refleja el esfuerzo.'
}, {
  icon: '🔄',
  title: 'Siempre el mismo ciclo',
  desc: 'Cada parcial es una crisis nueva. Y nunca termina.'
}];
export function PainPoints() {
  return <section className="py-20 px-6 lg:px-8 bg-white" data-id="element-136">
      <div className="max-w-[1100px] mx-auto" data-id="element-137">
        <SectionHeader data-id="element-138" />
        <div className="text-center mb-16" data-id="element-139">
          <h2 className="text-4xl md:text-5xl font-extrabold mb-4" data-id="element-140">
            ¿TE PASA ESTO?
          </h2>
          <p className="text-xl text-dark/70 font-medium" data-id="element-141">
            Si sos estudiante en Argentina, esto te suena familiar:
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-6 items-stretch mb-16" data-id="element-142">
          {painPoints.map((point, idx) => <div key={idx} className="bg-white p-3 md:p-6 rounded-[10px] md:rounded-2xl border border-[#EEEEEE] shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-143">
              <div className="flex items-center gap-2 md:block mb-1.5 md:mb-4" data-id="element-144">
                <span className="text-2xl md:text-4xl md:mb-0 leading-none" data-id="element-145">
                  {point.icon}
                </span>
                <h3 className="font-bold text-[13px] md:text-lg leading-tight md:mt-4 md:mb-2" data-id="element-146">
                  {point.title}
                </h3>
              </div>
              <p className="text-[11px] md:text-sm text-dark/60 leading-[1.4] md:leading-relaxed" data-id="element-147">
                {point.desc}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-148">
          <h3 className="text-2xl md:text-3xl font-bold bg-sun/30 inline-block px-6 py-3 rounded-xl" data-id="element-149">
            ¿Cuántos parciales más vas a encarar sin un sistema que funcione?
          </h3>
        </div>
      </div>
    </section>;
}